import React, { useContext, useState, useRef, useEffect } from "react";
import { LayoutContext } from "../shop/index";
import { isAuthenticate, isAdmin } from "../auth/fetchApi";
import toast from "react-hot-toast";
import { Menu, ChevronDown, Gauge, House, LogOut } from "lucide-react";

const Navbar = ({ isAdminView }) => {
    const { colors, toggleSidebar } = useContext(LayoutContext);
    const [showUserMenu, setShowUserMenu] = useState(false);
    const menuRef = useRef(null);

    const handleLogout = () => {
        localStorage.removeItem("jwt");
        toast.success("Logged out successfully!");
        setTimeout(() => window.location.href = "/login", 500);
    };

    const formatDisplayName = (fullName) => {
        if (!fullName) return "Guest";
        const nameArray = fullName.trim().split(" ");
        return nameArray.length >= 2 ? nameArray.slice(-2).join(" ") : fullName;
    };

    const getInitial = (fullName) => {
        return formatDisplayName(fullName).charAt(0).toUpperCase();
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowUserMenu(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <nav className="d-flex justify-content-between align-items-center px-4 w-100 shadow-sm"
            style={{
                height: '70px',
                minHeight: '70px',
                backgroundColor: colors.bgApp,
                // NÂNG CẤP Z-INDEX: Đảm bảo Navbar luôn nằm trên cùng
                zIndex: 1050,
                position: 'relative', // Hoặc 'sticky top-0' tùy cấu trúc app của bạn
                borderBottom: isAdminView ? 'none' : `1px solid ${colors.borderColor}`,
                transition: "background-color 0.3s ease"
            }}>

            {/* --- LEFT SECTION --- */}
            {isAdminView ? (
                <div onClick={toggleSidebar}
                    className="d-flex justify-content-center align-items-center rounded-3 hover-card"
                    style={{
                        width: '40px', height: '40px',
                        backgroundColor: colors.bgCard,
                        border: `1px solid ${colors.borderColor}`,
                        cursor: 'pointer'
                    }}>
                    <Menu size={24} style={{ color: colors.textMain }} />
                </div>
            ) : (
                <div
                    className="d-flex align-items-center"
                    style={{ cursor: 'pointer' }}
                    onClick={() => window.location.href = "/"}
                >
                    <h4 className="fw-bold m-0" style={{ letterSpacing: '3px', color: colors.activeMenu }}>HANDDN</h4>
                    <span className="ms-3 px-2 py-1 rounded shadow-sm d-none d-sm-inline-block" style={{
                        fontSize: '10px',
                        backgroundColor: colors.bgCard,
                        color: colors.textMuted,
                        border: `1px solid ${colors.borderColor}`,
                        letterSpacing: '1px'
                    }}>
                        BESPOKE
                    </span>
                </div>
            )}

            {/* --- RIGHT SECTION (USER PROFILE) --- */}
            <div className="position-relative" ref={menuRef} style={{ zIndex: 2000 }}>
                {isAuthenticate() ? (
                    <div className="d-flex align-items-center gap-2 p-1 pe-3 rounded-pill"
                        style={{
                            cursor: 'pointer',
                            backgroundColor: showUserMenu ? 'rgba(197, 160, 117, 0.1)' : 'transparent',
                            border: `1px solid ${showUserMenu ? colors.activeMenu : 'transparent'}`,
                            transition: 'all 0.3s ease'
                        }}
                        onClick={() => setShowUserMenu(!showUserMenu)}>

                        <div className="rounded-circle d-flex justify-content-center align-items-center text-white fw-bold shadow-sm"
                            style={{
                                width: '36px', height: '36px',
                                backgroundColor: colors.activeMenu,
                                fontSize: '15px'
                            }}>
                            {getInitial(isAuthenticate().user.name)}
                        </div>

                        <span className="fw-bold pe-2 d-none d-md-inline" style={{ fontSize: '14px', color: colors.textMain }}>
                            {formatDisplayName(isAuthenticate().user.name)}
                        </span>

                        <ChevronDown size={12} style={{
                            color: showUserMenu ? colors.activeMenu : colors.textMuted,
                            transition: 'transform 0.3s ease',
                            transform: showUserMenu ? 'rotate(-180deg)' : 'rotate(0deg)'
                        }} />
                    </div>
                ) : (
                    <a href="/login" className="btn rounded-pill px-4 fw-bold shadow-sm" style={{ backgroundColor: colors.activeMenu, color: '#fff' }}>Log In</a>
                )}

                {/* --- DROPDOWN MENU (Z-INDEX CAO NHẤT) --- */}
                {isAuthenticate() && (
                    <div className="position-absolute shadow-lg mt-2 overflow-hidden"
                        style={{
                            right: 0,
                            top: '100%',
                            minWidth: '200px',
                            backgroundColor: colors.bgCard,
                            border: `1px solid ${colors.borderColor}`,
                            borderRadius: '16px',
                            // CỰC KỲ QUAN TRỌNG: Nổi trên mọi Component
                            zIndex: 9999,
                            opacity: showUserMenu ? 1 : 0,
                            visibility: showUserMenu ? 'visible' : 'hidden',
                            transform: showUserMenu ? 'translateY(0)' : 'translateY(-10px)',
                            transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
                            pointerEvents: showUserMenu ? 'auto' : 'none'
                        }}>

                        {isAdmin() && !isAdminView && (
                            <a href="/admin/dashboard" className="d-flex align-items-center gap-3 p-3 text-start fw-bold dropdown-item-luxury"
                                style={{ color: colors.textMain, textDecoration: 'none', borderBottom: `1px solid ${colors.borderColor}` }}>
                                <Gauge size={16} /> Admin Panel
                            </a>
                        )}

                        {isAdminView && (
                            <a href="/" className="d-flex align-items-center gap-3 p-3 text-start fw-bold dropdown-item-luxury"
                                style={{ color: colors.textMain, textDecoration: 'none', borderBottom: `1px solid ${colors.borderColor}` }}>
                                <House size={16} /> Back to Home
                            </a>
                        )}

                        <div className="d-flex align-items-center gap-3 p-3 text-danger fw-bold dropdown-item-luxury"
                            style={{ cursor: 'pointer', fontSize: '14px' }}
                            onClick={handleLogout}>
                            <LogOut size={16} /> Log Out
                        </div>
                    </div>
                )}
            </div>

            {/* CSS inline để xử lý hover dropdown item mượt mà */}
            <style>{`
                .dropdown-item-luxury:hover {
                    background-color: rgba(197, 160, 117, 0.08) !important;
                    transition: all 0.2s ease;
                }
            `}</style>
        </nav>
    );
};

export default Navbar;